import React, { Component, createRef } from "react";
import "./index.css";
import { loadScript } from "../../functions/loadScript";

class GoogleMaps extends Component {
  ref = createRef();
  map = null;
  marker = null;
  coords = {
    lat: 42.68058,
    lng: 23.400328
  };

  shouldComponentUpdate() {
    return false;
  }

  loadGoogleMaps = async () => {
    try {
      const { apiKey } = this.props;
      const isLoaded = await loadScript(`https://maps.google.com/maps/api/js?key=${apiKey}`);
      if (isLoaded) {
        this.initGoogleMaps();
      }
    } catch (err) {
      console.log(err);
    }
  };

  initGoogleMaps = () => {
    const { maps } = window.google;
    this.map = new maps.Map(this.ref.current, {
      center: { ...this.coords },
      zoom: 14
    });
    this.marker = new maps.Marker({
      position: { ...this.coords },
      map: this.map,
      title: "СЛС Имоти"
    });
  };

  componentDidMount() {
    if (process.env.NODE_ENV === "development") return;
    this.loadGoogleMaps();
  }

  render() {
    return <div className="google-maps" ref={this.ref}></div>;
  }
}

export default GoogleMaps;



// WEBPACK FOOTER //
// ./src/presentational/GoogleMaps/index.js